import { combineEpics, Epic, ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import * as types from './types';
import { loopBackApi } from '../../models/LoopBack/Api/LoopBackApi';

const MyCustomersEpic: Epic<any, any> = (action$, store) =>
  action$.pipe(
    ofType(types.GET_MY_CUSTOMERS_REQUEST),
    mergeMap((action) =>
      loopBackApi()
        .get(`customers/by-user`, action.payload)
        .then((res) => ({
          type: types.GET_MY_CUSTOMERS_RECEIVE,
          payload: res.data
        }))
        .catch((err) => ({ type: types.GET_MY_CUSTOMERS_ERROR }))
    )
  );

export const customerEpics = combineEpics(MyCustomersEpic);
